import { render } from "./UsersAdd.vue?vue&type=template&id=44f5950c"
import script from "./UsersAdd.vue?vue&type=script&lang=js"
export * from "./UsersAdd.vue?vue&type=script&lang=js"

import "./UsersAdd.vue?vue&type=style&index=0&id=44f5950c&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__